import styled from "styled-components";

const URL = styled.input`
  border: 1px solid #007aff;
  border-left: 0;
  border-radius: 0 2px 2px 0;
  vertical-align: bottom;
  line-height: 20px;
  height: 20px;
  width: 500px;
  max-width: 100%;
  box-sizing: border-box;
`;

export default URL;
